import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShareProcessListService } from 'src/services/share-process-list.service';

@Component({
  selector: 'app-process-list-share-dialog',
  templateUrl: './process-list-share-dialog.component.html',
  styleUrls: ['./process-list-share-dialog.component.scss']
})
export class ProcessListShareDialogComponent implements OnInit {

  submiting: boolean = false;
  user: any;
  processList: any;
  shareLink: any;
  apiUrl: any;
  currentProcessListId: any;
  previewImage: any;
  imageLoading: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private shareProcessList: ShareProcessListService,
  ) { 

    if(data){
      this.user = JSON.parse(localStorage.getItem('token'));
      this.processList = data.processList;
      this.shareLink = this.shareProcessList.shareview(this.processList, this.user.company_id);
      this.apiUrl = data.apiUrl;
      this.currentProcessListId = data.currentProcessListId;
      this.previewImage = `${this.apiUrl}?action=creative:generate-image&company_id=${this.user.company_id}&process_id=${this.currentProcessListId}`;
    }
  }

  ngOnInit(): void {
    this.startLoadingTimer();  
  }

  copyLink(processList) {
    const companyID = this.user.company_id;
    this.shareProcessList.share(processList, companyID);
  }

  downloadPDF() {
    const user = JSON.parse(localStorage.getItem('token'));
    window.open(`${this.apiUrl}?action=creative&company_id=${user.company_id}&process_id=${this.currentProcessListId}`, '_blank')
  }

  downloadPNG() {
    const user = JSON.parse(localStorage.getItem('token'));
    const imageUrl = `${this.apiUrl}?action=creative:generate-image&company_id=${user.company_id}&process_id=${this.currentProcessListId}`;

    // Faz a requisição para buscar a imagem como Blob (arquivo binário)
    fetch(imageUrl)
        .then(response => response.blob()) // Converte a resposta em um Blob
        .then(blob => {
            // Criar URL temporária do arquivo
            const url = URL.createObjectURL(blob);

            // Criar elemento <a> para forçar o download
            const a = document.createElement('a');
            a.href = url;
            a.download = `process_${this.currentProcessListId}_compartilhe.png`; // Nome do arquivo
            document.body.appendChild(a);
            a.click();

            // Remover o link temporário
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        })
        .catch(error => console.error('Erro ao baixar a imagem:', error));
  }

  startLoadingTimer(): void {
    setTimeout(() => {
      this.imageLoading = false;
    }, 3000); // Tempo de espera de 3 segundos
  }  

}
